import { format } from "date-fns";
import { de } from "date-fns/locale";

const formatToLocalDate = (date: Date) => format(date, "dd.MM.yyyy HH:mm", { locale: de });

export const UtcToLocale = ({ datetime }: { datetime?: string }): React.ReactElement => {

  if (!datetime) {
    return <>-</>;
  }

  // check if datetime string already has trailing Z
  let dateString = datetime;
  if (!dateString.endsWith("Z")) {
    dateString = dateString.concat("Z");
  }

  const dateObj = new Date(dateString);

  // Check if the date is actually valid before formatting
  if (isNaN(dateObj.getTime())) {
    return <>-</>;
  }

  const localDate = formatToLocalDate(dateObj);

  return <>{localDate}</>;
};
